<div class="row top-header justify-content-center">

  <div class="col-md-8 text-center">
    <div>

      <mat-icon style="vertical-align: middle; margin-right: 5px;">mail</mat-icon>
      <a href="mailto:service@snpmoney.com" style="text-decoration: none; color: inherit;">
        service&#64;snpmoney.com
      </a>
      <mat-icon style="vertical-align: middle; margin-right: 5px;">phone</mat-icon>
      <a href="tel:+919372656044" style="text-decoration: none; color: inherit;">
        +91 93726 56044
      </a>
    </div>
  </div>





  <div class="col-md-3">
    <div class="schedule-btn">
      <a href="#" routerLink="contactUs">Schedule Your Free Consultation</a>
    </div>
  </div>
</div>

<nav class="navbar navbar-expand-lg">
  <div class="container-fluid mt-6">
    <!-- Logo -->
    <a class="navbar-brand" href="https://snpmoney.com">
      <img src="assets\snp Image\size changed png1.jpg" alt="Logo">
    </a>

    <!-- Mobile Menu Toggle -->
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown"
      aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Navbar Links -->
    <div class="collapse navbar-collapse" id="navbarNavDropdown">
      <ul class="navbar-nav justify-content-center" style="flex: auto">
        <!-- Loop through menu items -->
        <li *ngFor="let item of menuItems" class="nav-item">
          <!-- Regular Links (Desktop) -->
          <a *ngIf="!item.isDropdown" mat-button [routerLink]="item.link" style="font-family: 'Poppins', sans-serif;">
            {{ item.label }}
          </a>

          <!-- Services Dropdown (Desktop and Mobile) -->
          <ng-container *ngIf="item.isDropdown">
            <a mat-button [matMenuTriggerFor]="servicesMenu" style="font-family: 'Poppins', sans-serif;">
              {{ item.label }}
            </a>
            <mat-menu #servicesMenu="matMenu">
              <!-- Financial Planning Dropdown -->
              <ng-container *ngIf="item.label === 'Financial Planning'">
                <button mat-menu-item *ngFor="let dropdownItem of item.dropdownItems" [routerLink]="dropdownItem.link">
                  {{ dropdownItem.label }}
                </button>
              </ng-container>

              <!-- Insurance Dropdown -->
              <ng-container *ngIf="item.label === 'Insurance'">
                <button mat-menu-item *ngFor="let dropdownItem of item.dropdownItems" [routerLink]="dropdownItem.link">
                  {{ dropdownItem.label }}
                </button>
              </ng-container>
            </mat-menu>
          </ng-container>
        </li>
      </ul>

      <!-- Login Button -->
      <div class="mt-4">
        <a mat-raised-button href="https://snpwealth.investwell.app/" target="_blank" class="fancy-button"
          color="primary">
          LOGIN
        </a>
      </div>
    </div>
  </div>
</nav>

<!-- Mobile Services Menu -->
<mat-menu #mobileServicesMenu="matMenu">
  <!-- Financial Planning Dropdown (Mobile) -->
  <ng-container *ngIf="menuItems[3].label === 'Financial Planning'">
    <button mat-menu-item *ngFor="let dropdownItem of menuItems[3].dropdownItems" [routerLink]="dropdownItem.link">
      {{ dropdownItem.label }}
    </button>
  </ng-container>

  <!-- Insurance Dropdown (Mobile) -->
  <ng-container *ngIf="menuItems[4].label === 'Insurance'">
    <button mat-menu-item *ngFor="let dropdownItem of menuItems[4].dropdownItems" [routerLink]="dropdownItem.link">
      {{ dropdownItem.label }}
    </button>
  </ng-container>
</mat-menu>
